<template>
  <div v-if="versionList.length" class="version-history-table">
    <p class="d-history-title">历史版本</p>
    <ul>
      <template v-for="(row, index) in versionList">
        <li
          v-if="showAll || (!showAll && index < 5)"
          :key="index"
          @click="historyVersionTap(row)"
        >
          <div v-if="index === 0 && latestTag" class="latest-sign">New</div>
          <span>{{ row.version }}</span>
          <span>{{ row.releaseTime }}</span>
        </li>
      </template>
    </ul>
    <p v-if="!showAll && versionList.length > 5" class="show-all">
      <span @click="showAll = true">查看更多</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    versionList: {
      type: Array,
      default: () => []
    },
    latestTag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAll: false
    }
  },
  methods: {
    historyVersionTap(row) {
      this.$router.push({
        query: {
          ...this.$route.query,
          version: row.version
        }
      });
      history.go(0);
    }
  }
}
</script>

<style lang="scss" scoped>
.version-history-table {
  padding: 50px 20px;
  .d-history-title {
    font-size: 21px;
    margin-bottom: 20px;
  }
  ul {
    li {
      list-style: none;
      padding: 0 20px;
      position: relative;
      .latest-sign {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        background: #e82945;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        padding: 2px 6px;
      }
      &:nth-child(2n + 1) {
        background: #eff4f6;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        width: 50%;
        line-height: 36px;
        height: 36px;
        font-size: 14px;
        color: #969b9d;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .show-all {
    text-align: right;
    font-size: 14px;
    color: #7c8183;
    padding: 12px 8px;
    cursor: pointer;
    &:hover {
      color: #333;
    }
  }
}
</style>
